import { useEffect, useState } from 'react';
import useAuth from 'hooks/useAuth';
import axiosServices from 'utils/axios';
import { getSubdomainFromHost } from 'utils/org';

export default function useOrgLogo() {
  const { isLoggedIn } = useAuth();
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        const params = isLoggedIn ? {} : { subdomain: getSubdomainFromHost(window.location.hostname) };
        const { data } = await axiosServices.get('/setups', { params });
        const first = Array.isArray(data) ? data[0] : null;

        if (mounted) setLogoUrl(first?.logo_url || null);
      } catch (error) {
        console.error('Failed to load org logo', error);
        if (mounted) setLogoUrl(null);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [isLoggedIn]);

  return logoUrl;
}